import React from "react";
import { useFormContext, Controller } from "react-hook-form";

import CustomError from "../../../shared/components/custom-error/CustomError";
import FileUploader from "../../../shared/components/file-uploader/FileUploader";
import { allowedFileTypesForRegistrationCertificate } from "../../../constants";

const EmergencyContactForm = () => {
  const {
    formState: { errors },
    watch,
    control,
  } = useFormContext();

  const files = watch("emergencyContactInfo.files");
  const headshotfiles = watch("emergencyContactInfo.headshotfiles");
  const document = watch("document");

  return (
    <div className="emergency-contact-information">
      <div className="row">
        <div className="col-12 emergency-contact-information-heading">
          Identification Documents
        </div>
        {/* upload your photo id field */}
        <div className="col-12 col-lg-6 pe-xl-4">
          <div className="upload-photo-wrapper">
            <div className="upload-photo mb-3">
              Upload your Photo ID: <span>Front and Back</span>
            </div>
            <Controller
              name="emergencyContactInfo.files"
              control={control}
              render={({ field: { onChange } }) => (
                <FileUploader
                  files={files || []}
                  onChange={onChange}
                  handleDelete={(index) => {
                    const updatedFiles = [...(files || [])];
                    updatedFiles.splice(index, 1);
                    onChange(updatedFiles);
                  }}
                  maxFiles={2}
                />
              )}
            />
            <CustomError
              errorMessage={errors.emergencyContactInfo?.files?.message}
            />
          </div>
        </div>
        {/* upload headshot photo field */}
        <div className="col-12 col-lg-6 ps-xl-4">
          <div className="upload-photo-wrapper">
            <div className="upload-photo mb-3">
              Upload Professional Headshot:
            </div>
            <Controller
              name="emergencyContactInfo.headshotfiles"
              control={control}
              render={({ field: { onChange } }) => (
                <FileUploader
                  files={headshotfiles || []}
                  onChange={onChange}
                  handleDelete={(index) => {
                    const updatedFiles = [...(headshotfiles || [])];
                    updatedFiles.splice(index, 1);
                    onChange(updatedFiles);
                  }}
                  maxFiles={1}
                />
              )}
            />
            <CustomError
              errorMessage={errors.emergencyContactInfo?.headshotfiles?.message}
            />
          </div>
        </div>
        {/* upload registration certificate field */}
        <div className="col-12 col-lg-6 pe-xl-4">
          <div className="upload-photo-wrapper">
            <div className="upload-photo mb-3">
              Upload Company Registration Certificate:
            </div>
            <Controller
              name="document"
              control={control}
              render={({ field: { onChange } }) => (
                <FileUploader
                  files={document || []}
                  accept={allowedFileTypesForRegistrationCertificate}
                  onChange={onChange}
                  handleDelete={(index) => {
                    const updatedFiles = [...(document || [])];
                    updatedFiles.splice(index, 1);
                    onChange(updatedFiles);
                  }}
                  maxFiles={1}
                />
              )}
            />
            <CustomError errorMessage={errors?.document?.message} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmergencyContactForm;
